import { useMutation } from "@tanstack/react-query";
import { register, RegistrationArgs } from "../../apis";

export function useRegister() {
  const {
    mutate: handleRegister,
    error,
    status,
    data,
  } = useMutation({
    mutationFn: (data: RegistrationArgs) => {
      return register(data);
    },
  });

  return {
    handleRegister,
    error,
    status,
    result: data,
    isLoading: status === "pending",
  };
}
